<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-10-17 21:06:22
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTabAdd">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-page-header
              @back="goBack"
              :content="editId == '' ? '新增菜单' : '编辑菜单'"
            >
            </el-page-header>
          </div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="类型" prop="type">
              <el-select
                v-model="ruleForm.type"
                placeholder="请选择"
                clearable
                style="margin-right: auto;"
              >
                <el-option label="目录" value="0"></el-option>
                <el-option label="菜单" value="1"></el-option>
                <el-option label="按钮" value="2"></el-option>
                <el-option label="按钮菜单" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="菜单名称" prop="name">
              <el-input
                v-model="ruleForm.name"
                placeholder="请输入菜单名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="上级菜单" prop="path">
              <el-cascader
                style="margin-right: auto;"
                :props="cateProps"
                :show-all-levels="true"
                v-model="selectData"
                :options="postList"
                @change="handleChange"
              ></el-cascader>
            </el-form-item>
            <!-- <el-form-item label="菜单深度" prop="dept">
              <el-select
                v-model="ruleForm.dept"
                placeholder="请选择"
                clearable
                style="margin-right: auto;"
              >
                <el-option label="一级菜单" value="1"></el-option>
                <el-option label="二级菜单" value="2"></el-option>
                <el-option label="按钮" value="9"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="菜单路由" prop="url">
              <el-input
                v-model="ruleForm.url"
                placeholder="请输入菜单路由"
              ></el-input>
            </el-form-item>
            <el-form-item label="接口" prop="apisAuth">
              <el-input
                v-model="ruleForm.apisAuth"
                placeholder="请以逗号分隔填写接口地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="排序号" prop="sort">
              <el-input
                v-model="ruleForm.sort"
                placeholder="请输入排序号"
              ></el-input>
            </el-form-item>
            <el-form-item label="菜单图标">
              <el-popover
                ref="popover"
                placement="bottom"
                width="500"
                trigger="click"
                v-model="visible"
              >
                <div slot="reference">
                  <div
                    v-if="ruleForm.icon == '' || ruleForm.icon == null"
                    style="color: rgb(107, 107, 241);cursor: pointer;"
                    @click="visible == !visible"
                  >
                    添加图标
                  </div>
                  <i :class="['iconfont', 'icon-' + ruleForm.icon]" v-else></i>
                </div>
                <div class="iconBox">
                  <i
                    v-for="(item, index) in iconList"
                    :key="index"
                    :class="['iconfont', 'icon-' + item.font_class]"
                    @click="selectIcon(item.font_class)"
                  ></i>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item>
              <el-button @click="close()">取消</el-button>
              <el-button
                @click="submitForm('ruleForm')"
                class="btn"
                style="margin-right: auto;"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system
  },
  data() {
    return {
      leftList: this.Plugins.systemData(),
      ruleForm: {
        type: "",
        name: "",
        pid: "",
        sort: "",
        path: "",
        url: "",
        icon: "",
        apisAuth: ""
      },
      rules: {
        name: [{ required: true, message: "必填项", trigger: "blur" }],
        // apisAuth: [{ required: true, message: "必填项", trigger: "blur" }],
        path: [{ required: true, message: "必填项", trigger: "change" }]
        // dept: [{ required: true, message: "必填项", trigger: "change" }]
      },
      postList: [],
      editId: "",
      cateProps: {
        label: "name",
        value: "id",
        checkStrictly: true
      },
      selectData: [],
      iconList: [
        {
          icon_id: "5387377",
          name: "标签",
          font_class: "biaoqian",
          unicode: "eabd",
          unicode_decimal: 60093
        },
        {
          icon_id: "5387378",
          name: "打印机",
          font_class: "dayinji",
          unicode: "eabe",
          unicode_decimal: 60094
        },
        {
          icon_id: "5387379",
          name: "保存",
          font_class: "baocun",
          unicode: "eabf",
          unicode_decimal: 60095
        },
        {
          icon_id: "5387381",
          name: "导出",
          font_class: "daochu",
          unicode: "eac0",
          unicode_decimal: 60096
        },
        {
          icon_id: "5387382",
          name: "导入",
          font_class: "daoru",
          unicode: "eac1",
          unicode_decimal: 60097
        },
        {
          icon_id: "5387387",
          name: "键盘",
          font_class: "jianpan",
          unicode: "eac2",
          unicode_decimal: 60098
        },
        {
          icon_id: "5387390",
          name: "手机",
          font_class: "shouji",
          unicode: "eac3",
          unicode_decimal: 60099
        },
        {
          icon_id: "5387392",
          name: "图片",
          font_class: "tupian",
          unicode: "eac4",
          unicode_decimal: 60100
        },
        {
          icon_id: "5387393",
          name: "添加附件",
          font_class: "tianjiafujian",
          unicode: "eac5",
          unicode_decimal: 60101
        },
        {
          icon_id: "5387395",
          name: "办公包",
          font_class: "bangongbao",
          unicode: "eac6",
          unicode_decimal: 60102
        },
        {
          icon_id: "5387401",
          name: "仓库_库存详情",
          font_class: "cangku_kucunxiangqing",
          unicode: "eac8",
          unicode_decimal: 60104
        },
        {
          icon_id: "5387405",
          name: "服务管理",
          font_class: "fuwuguanli",
          unicode: "eaca",
          unicode_decimal: 60106
        },
        {
          icon_id: "5387406",
          name: "服务流",
          font_class: "fuwuliu",
          unicode: "eacb",
          unicode_decimal: 60107
        },
        {
          icon_id: "5387409",
          name: "工作流",
          font_class: "gongzuoliu",
          unicode: "eacc",
          unicode_decimal: 60108
        },
        {
          icon_id: "5387412",
          name: "电表",
          font_class: "dianbiao",
          unicode: "eacd",
          unicode_decimal: 60109
        },
        {
          icon_id: "5387413",
          name: "管理员搜索",
          font_class: "guanliyuansousuo",
          unicode: "eace",
          unicode_decimal: 60110
        },
        {
          icon_id: "5387415",
          name: "人工改承运商",
          font_class: "rengonggaichengyunshang",
          unicode: "eacf",
          unicode_decimal: 60111
        },
        {
          icon_id: "5387420",
          name: "设备打点",
          font_class: "shebeidadian",
          unicode: "ead0",
          unicode_decimal: 60112
        },
        {
          icon_id: "5387421",
          name: "上架",
          font_class: "shangjia",
          unicode: "ead1",
          unicode_decimal: 60113
        },
        {
          icon_id: "5387424",
          name: "设备搜索",
          font_class: "shebeisousuo",
          unicode: "ead2",
          unicode_decimal: 60114
        },
        {
          icon_id: "5387425",
          name: "设备检测",
          font_class: "shebeijiance",
          unicode: "ead3",
          unicode_decimal: 60115
        },
        {
          icon_id: "5387430",
          name: "异常上报",
          font_class: "yichangshangbao",
          unicode: "ead6",
          unicode_decimal: 60118
        },
        {
          icon_id: "5387431",
          name: "中控",
          font_class: "zhongkong",
          unicode: "ead7",
          unicode_decimal: 60119
        },
        {
          icon_id: "5387459",
          name: "购物袋",
          font_class: "gouwudai",
          unicode: "ead9",
          unicode_decimal: 60121
        },
        {
          icon_id: "5387460",
          name: "购物",
          font_class: "gouwu",
          unicode: "eada",
          unicode_decimal: 60122
        },
        {
          icon_id: "5387463",
          name: "机器人",
          font_class: "jiqiren",
          unicode: "eadb",
          unicode_decimal: 60123
        },
        {
          icon_id: "5387486",
          name: "语音",
          font_class: "yuyin",
          unicode: "eae6",
          unicode_decimal: 60134
        },
        {
          icon_id: "5387487",
          name: "钥匙",
          font_class: "yuechi",
          unicode: "eae7",
          unicode_decimal: 60135
        },
        {
          icon_id: "5387497",
          name: "钻石",
          font_class: "zuanshi",
          unicode: "eaee",
          unicode_decimal: 60142
        },
        {
          icon_id: "5387520",
          name: "二维码",
          font_class: "erweima",
          unicode: "eaf1",
          unicode_decimal: 60145
        },
        {
          icon_id: "5387536",
          name: "历史记录",
          font_class: "lishijilu",
          unicode: "eaf7",
          unicode_decimal: 60151
        },
        {
          icon_id: "5387537",
          name: "灵感",
          font_class: "linggan",
          unicode: "eaf8",
          unicode_decimal: 60152
        },
        {
          icon_id: "5387539",
          name: "品类减少",
          font_class: "pinleijianshao",
          unicode: "eaf9",
          unicode_decimal: 60153
        },
        {
          icon_id: "5387544",
          name: "扫一扫",
          font_class: "saoyisao1",
          unicode: "eafa",
          unicode_decimal: 60154
        },
        {
          icon_id: "5387551",
          name: "提示",
          font_class: "tishi",
          unicode: "eafe",
          unicode_decimal: 60158
        },
        {
          icon_id: "5387552",
          name: "任务中心",
          font_class: "renwuzhongxin",
          unicode: "eafd",
          unicode_decimal: 60157
        },
        {
          icon_id: "5387554",
          name: "图文",
          font_class: "tuwen",
          unicode: "eaff",
          unicode_decimal: 60159
        },
        {
          icon_id: "5387558",
          name: "相机",
          font_class: "xiangji1",
          unicode: "eb01",
          unicode_decimal: 60161
        },
        {
          icon_id: "5387559",
          name: "页面框架",
          font_class: "yemiankuangjia",
          unicode: "eb02",
          unicode_decimal: 60162
        },
        {
          icon_id: "5387572",
          name: "按钮_箭头展开",
          font_class: "anniu_jiantouzhankai",
          unicode: "eb03",
          unicode_decimal: 60163
        },
        {
          icon_id: "5387625",
          name: "金币",
          font_class: "jinbi",
          unicode: "eb19",
          unicode_decimal: 60185
        },
        {
          icon_id: "5387626",
          name: "存款",
          font_class: "cunkuan",
          unicode: "eb18",
          unicode_decimal: 60184
        },
        {
          icon_id: "5387627",
          name: "美元",
          font_class: "meiyuan",
          unicode: "eb1a",
          unicode_decimal: 60186
        },
        {
          icon_id: "5387630",
          name: "账单_空",
          font_class: "zhangdan_kong",
          unicode: "eb1b",
          unicode_decimal: 60187
        },
        {
          icon_id: "5387631",
          name: "账单_详情",
          font_class: "zhangdan_xiangqing",
          unicode: "eb1c",
          unicode_decimal: 60188
        },
        {
          icon_id: "5387632",
          name: "账单_取消",
          font_class: "zhangdan_quxiao",
          unicode: "eb1d",
          unicode_decimal: 60189
        },
        {
          icon_id: "5387638",
          name: "人民币",
          font_class: "renminbi",
          unicode: "eb1e",
          unicode_decimal: 60190
        },
        {
          icon_id: "5387639",
          name: "资金_冻结",
          font_class: "zijin_dongjie",
          unicode: "eb1f",
          unicode_decimal: 60191
        },
        {
          icon_id: "5387648",
          name: "电话",
          font_class: "dianhua1",
          unicode: "eb23",
          unicode_decimal: 60195
        },
        {
          icon_id: "5387649",
          name: "短信",
          font_class: "duanxin",
          unicode: "eb24",
          unicode_decimal: 60196
        },
        {
          icon_id: "5387686",
          name: "包裹_收货",
          font_class: "baoguo_shouhuo",
          unicode: "eb30",
          unicode_decimal: 60208
        },
        {
          icon_id: "11372639",
          name: "爱心",
          font_class: "aixin",
          unicode: "e8ab",
          unicode_decimal: 59563
        },
        {
          icon_id: "11372640",
          name: "编辑",
          font_class: "bianji",
          unicode: "e8ac",
          unicode_decimal: 59564
        },
        {
          icon_id: "11372649",
          name: "测试",
          font_class: "ceshi",
          unicode: "e8ad",
          unicode_decimal: 59565
        },
        {
          icon_id: "11372650",
          name: "电话",
          font_class: "dianhua",
          unicode: "e8ae",
          unicode_decimal: 59566
        },
        {
          icon_id: "11372654",
          name: "电影",
          font_class: "dianying",
          unicode: "e8af",
          unicode_decimal: 59567
        },
        {
          icon_id: "11372655",
          name: "地图",
          font_class: "ditu",
          unicode: "e8b0",
          unicode_decimal: 59568
        },
        {
          icon_id: "11372671",
          name: "减少",
          font_class: "jianshao",
          unicode: "e8b1",
          unicode_decimal: 59569
        },
        {
          icon_id: "11372672",
          name: "卡包",
          font_class: "kabao",
          unicode: "e8b2",
          unicode_decimal: 59570
        },
        {
          icon_id: "11372674",
          name: "关注",
          font_class: "guanzhu",
          unicode: "e8b3",
          unicode_decimal: 59571
        },
        {
          icon_id: "11372685",
          name: "扫一扫",
          font_class: "saoyisao",
          unicode: "e8b5",
          unicode_decimal: 59573
        },
        {
          icon_id: "11372686",
          name: "日历",
          font_class: "rili",
          unicode: "e8b4",
          unicode_decimal: 59572
        },
        {
          icon_id: "11372687",
          name: "评论",
          font_class: "pinglun",
          unicode: "e8b6",
          unicode_decimal: 59574
        },
        {
          icon_id: "11372689",
          name: "日签",
          font_class: "riqian",
          unicode: "e8b7",
          unicode_decimal: 59575
        },
        {
          icon_id: "11372703",
          name: "首页",
          font_class: "shouye",
          unicode: "e8b9",
          unicode_decimal: 59577
        },
        {
          icon_id: "11372704",
          name: "数据",
          font_class: "shuju",
          unicode: "e8ba",
          unicode_decimal: 59578
        },
        {
          icon_id: "11372705",
          name: "刷新",
          font_class: "shuaxin",
          unicode: "e8bb",
          unicode_decimal: 59579
        },
        {
          icon_id: "11372706",
          name: "搜索",
          font_class: "sousuo",
          unicode: "e8bc",
          unicode_decimal: 59580
        },
        {
          icon_id: "11372716",
          name: "我的",
          font_class: "wode",
          unicode: "e8bd",
          unicode_decimal: 59581
        },
        {
          icon_id: "11372717",
          name: "微信",
          font_class: "weixin",
          unicode: "e8be",
          unicode_decimal: 59582
        },
        {
          icon_id: "11372721",
          name: "相机",
          font_class: "xiangji",
          unicode: "e8bf",
          unicode_decimal: 59583
        },
        {
          icon_id: "11372722",
          name: "消息",
          font_class: "xiaoxi",
          unicode: "e8c0",
          unicode_decimal: 59584
        },
        {
          icon_id: "11372726",
          name: "消息中心",
          font_class: "xiaoxizhongxin",
          unicode: "e8c1",
          unicode_decimal: 59585
        },
        {
          icon_id: "11372727",
          name: "银行卡",
          font_class: "yinhangka",
          unicode: "e8c2",
          unicode_decimal: 59586
        },
        {
          icon_id: "11372731",
          name: "影评模板",
          font_class: "yingpingmoban",
          unicode: "e8c3",
          unicode_decimal: 59587
        },
        {
          icon_id: "11372739",
          name: "直播",
          font_class: "zhibo",
          unicode: "e8c4",
          unicode_decimal: 59588
        },
        {
          icon_id: "11372742",
          name: "指纹",
          font_class: "zhiwen",
          unicode: "e8c5",
          unicode_decimal: 59589
        },
        {
          icon_id: "37684063",
          name: "设置",
          font_class: "shezhi",
          unicode: "1017a",
          unicode_decimal: 65914
        },
        {
          icon_id: "7551129",
          name: "供应商",
          font_class: "RectangleCopy",
          unicode: "e6b0",
          unicode_decimal: 59056
        },
        {
          icon_id: "7551132",
          name: "人群",
          font_class: "RectangleCopy1",
          unicode: "e6b1",
          unicode_decimal: 59057
        },
        {
          icon_id: "7551133",
          name: "人群管理",
          font_class: "RectangleCopy2",
          unicode: "e6b2",
          unicode_decimal: 59058
        },
        {
          icon_id: "7551215",
          name: "商品发布管理",
          font_class: "RectangleCopy3",
          unicode: "e6b3",
          unicode_decimal: 59059
        },
        {
          icon_id: "7551216",
          name: "商品复制管理",
          font_class: "RectangleCopy4",
          unicode: "e6b4",
          unicode_decimal: 59060
        },
        {
          icon_id: "7551217",
          name: "商品复制",
          font_class: "RectangleCopy5",
          unicode: "e6b5",
          unicode_decimal: 59061
        },
        {
          icon_id: "7551218",
          name: "爆款商品",
          font_class: "RectangleCopy6",
          unicode: "e6b6",
          unicode_decimal: 59062
        },
        {
          icon_id: "7551219",
          name: "商品备案管理",
          font_class: "RectangleCopy7",
          unicode: "e6b7",
          unicode_decimal: 59063
        },
        {
          icon_id: "7551485",
          name: "结算单管理",
          font_class: "RectangleCopy8",
          unicode: "e6b8",
          unicode_decimal: 59064
        },
        {
          icon_id: "7551486",
          name: "结算报表",
          font_class: "RectangleCopy9",
          unicode: "e6b9",
          unicode_decimal: 59065
        },
        {
          icon_id: "7551487",
          name: "返利规则管理",
          font_class: "RectangleCopy10",
          unicode: "e6ba",
          unicode_decimal: 59066
        },
        {
          icon_id: "7551488",
          name: "月结管理",
          font_class: "RectangleCopy11",
          unicode: "e6bb",
          unicode_decimal: 59067
        },
        {
          icon_id: "7551804",
          name: "单据管理",
          font_class: "RectangleCopy12",
          unicode: "e6bc",
          unicode_decimal: 59068
        },
        {
          icon_id: "7551818",
          name: "进销存报表",
          font_class: "RectangleCopy13",
          unicode: "e6bd",
          unicode_decimal: 59069
        },
        {
          icon_id: "7552199",
          name: "库存管理",
          font_class: "RectangleCopy14",
          unicode: "e6c2",
          unicode_decimal: 59074
        },
        {
          icon_id: "7552200",
          name: "库存",
          font_class: "RectangleCopy15",
          unicode: "e6c3",
          unicode_decimal: 59075
        },
        {
          icon_id: "7552209",
          name: "退仓",
          font_class: "RectangleCopy16",
          unicode: "e6c4",
          unicode_decimal: 59076
        },
        {
          icon_id: "7552709",
          name: "绩效管理",
          font_class: "RectangleCopy17",
          unicode: "e6d2",
          unicode_decimal: 59090
        },
        {
          icon_id: "7552711",
          name: "活动管理",
          font_class: "RectangleCopy18",
          unicode: "e6d3",
          unicode_decimal: 59091
        },
        {
          icon_id: "7552718",
          name: "招商管理",
          font_class: "RectangleCopy19",
          unicode: "e6d4",
          unicode_decimal: 59092
        },
        {
          icon_id: "7552719",
          name: "品牌授权管理",
          font_class: "RectangleCopy20",
          unicode: "e6d5",
          unicode_decimal: 59093
        },
        {
          icon_id: "7552720",
          name: "生命周期管理",
          font_class: "RectangleCopy21",
          unicode: "e6d6",
          unicode_decimal: 59094
        },
        {
          icon_id: "7552721",
          name: "排期管理",
          font_class: "RectangleCopy22",
          unicode: "e6d7",
          unicode_decimal: 59095
        },
        {
          icon_id: "7552722",
          name: "销售管理",
          font_class: "RectangleCopy23",
          unicode: "e6d8",
          unicode_decimal: 59096
        },
        {
          icon_id: "7552723",
          name: "排期",
          font_class: "RectangleCopy24",
          unicode: "e6d9",
          unicode_decimal: 59097
        },
        {
          icon_id: "7552728",
          name: "菜鸟运营指标",
          font_class: "RectangleCopy25",
          unicode: "e6da",
          unicode_decimal: 59098
        },
        {
          icon_id: "7552730",
          name: "会场管理",
          font_class: "RectangleCopy26",
          unicode: "e6db",
          unicode_decimal: 59099
        },
        {
          icon_id: "7553181",
          name: "优化计划",
          font_class: "RectangleCopy27",
          unicode: "e6dc",
          unicode_decimal: 59100
        },
        {
          icon_id: "7553183",
          name: "清仓计划",
          font_class: "RectangleCopy28",
          unicode: "e6dd",
          unicode_decimal: 59101
        },
        {
          icon_id: "7553184",
          name: "销量计划",
          font_class: "RectangleCopy29",
          unicode: "e6de",
          unicode_decimal: 59102
        },
        {
          icon_id: "7553622",
          name: "成本查询",
          font_class: "RectangleCopy30",
          unicode: "e6df",
          unicode_decimal: 59103
        },
        {
          icon_id: "7553623",
          name: "结算工具箱",
          font_class: "RectangleCopy31",
          unicode: "e6e0",
          unicode_decimal: 59104
        },
        {
          icon_id: "7553627",
          name: "商家数据",
          font_class: "RectangleCopy32",
          unicode: "e6e1",
          unicode_decimal: 59105
        },
        {
          icon_id: "7553630",
          name: "前端商品毛利",
          font_class: "RectangleCopy33",
          unicode: "e6e2",
          unicode_decimal: 59106
        },
        {
          icon_id: "7553631",
          name: "财务分析",
          font_class: "RectangleCopy34",
          unicode: "e6e3",
          unicode_decimal: 59107
        },
        {
          icon_id: "7553632",
          name: "多维度看板",
          font_class: "RectangleCopy35",
          unicode: "e6e4",
          unicode_decimal: 59108
        },
        {
          icon_id: "7553634",
          name: "销量预测",
          font_class: "RectangleCopy36",
          unicode: "e6e5",
          unicode_decimal: 59109
        },
        {
          icon_id: "7553635",
          name: "实时预测",
          font_class: "RectangleCopy37",
          unicode: "e6e6",
          unicode_decimal: 59110
        },
        {
          icon_id: "7553636",
          name: "订单履约看板",
          font_class: "RectangleCopy38",
          unicode: "e6e7",
          unicode_decimal: 59111
        },
        {
          icon_id: "7553637",
          name: "实时看板",
          font_class: "RectangleCopy39",
          unicode: "e6e8",
          unicode_decimal: 59112
        },
        {
          icon_id: "7553638",
          name: "销量实时看板",
          font_class: "RectangleCopy40",
          unicode: "e6e9",
          unicode_decimal: 59113
        },
        {
          icon_id: "7553645",
          name: "运营工具",
          font_class: "RectangleCopy41",
          unicode: "e6ea",
          unicode_decimal: 59114
        },
        {
          icon_id: "7553655",
          name: "赚翻乐",
          font_class: "RectangleCopy42",
          unicode: "e6eb",
          unicode_decimal: 59115
        },
        {
          icon_id: "7553656",
          name: "目标监控",
          font_class: "RectangleCopy43",
          unicode: "e6ec",
          unicode_decimal: 59116
        },
        {
          icon_id: "7553666",
          name: "权益发放工具",
          font_class: "RectangleCopy44",
          unicode: "e6ed",
          unicode_decimal: 59117
        },
        {
          icon_id: "7553667",
          name: "全链路可售",
          font_class: "RectangleCopy45",
          unicode: "e6ee",
          unicode_decimal: 59118
        },
        {
          icon_id: "7553668",
          name: "素材中心",
          font_class: "RectangleCopy46",
          unicode: "e6ef",
          unicode_decimal: 59119
        },
        {
          icon_id: "7553669",
          name: "超级服务",
          font_class: "RectangleCopy47",
          unicode: "e6f0",
          unicode_decimal: 59120
        },
        {
          icon_id: "7553918",
          name: "上门取货",
          font_class: "RectangleCopy48",
          unicode: "e6f1",
          unicode_decimal: 59121
        },
        {
          icon_id: "7562286",
          name: "定位",
          font_class: "dingwei",
          unicode: "e6f2",
          unicode_decimal: 59122
        },
        {
          icon_id: "7733537",
          name: "物流",
          font_class: "RectangleCopy49",
          unicode: "e6f3",
          unicode_decimal: 59123
        },
        {
          icon_id: "7922986",
          name: "两季品",
          font_class: "liangjipin",
          unicode: "e6f4",
          unicode_decimal: 59124
        },
        {
          icon_id: "8776631",
          name: "view",
          font_class: "icon-test6",
          unicode: "e633",
          unicode_decimal: 58931
        },
        {
          icon_id: "8776676",
          name: "view_off",
          font_class: "icon-test7",
          unicode: "e634",
          unicode_decimal: 58932
        },
        {
          icon_id: "8776692",
          name: "message",
          font_class: "icon-test8",
          unicode: "e635",
          unicode_decimal: 58933
        },
        {
          icon_id: "8776711",
          name: "record",
          font_class: "icon-test10",
          unicode: "e639",
          unicode_decimal: 58937
        },
        {
          icon_id: "8776716",
          name: "credits",
          font_class: "icon-test12",
          unicode: "e63b",
          unicode_decimal: 58939
        },
        {
          icon_id: "8776769",
          name: "renew",
          font_class: "icon-test13",
          unicode: "e63d",
          unicode_decimal: 58941
        },
        {
          icon_id: "8776784",
          name: "order",
          font_class: "icon-test14",
          unicode: "e63f",
          unicode_decimal: 58943
        },
        {
          icon_id: "8776785",
          name: "order_unread",
          font_class: "icon-test15",
          unicode: "e640",
          unicode_decimal: 58944
        },
        {
          icon_id: "8776822",
          name: "cart_empty",
          font_class: "icon-test16",
          unicode: "e642",
          unicode_decimal: 58946
        },
        {
          icon_id: "8776823",
          name: "cart",
          font_class: "icon-test17",
          unicode: "e643",
          unicode_decimal: 58947
        },
        {
          icon_id: "8776843",
          name: "edit",
          font_class: "icon-test19",
          unicode: "e645",
          unicode_decimal: 58949
        },
        {
          icon_id: "8776872",
          name: "share",
          font_class: "icon-test21",
          unicode: "e647",
          unicode_decimal: 58951
        },
        {
          icon_id: "8776873",
          name: "setting",
          font_class: "icon-test22",
          unicode: "e648",
          unicode_decimal: 58952
        },
        {
          icon_id: "8776877",
          name: "upload",
          font_class: "icon-test23",
          unicode: "e649",
          unicode_decimal: 58953
        },
        {
          icon_id: "8776878",
          name: "download",
          font_class: "icon-test24",
          unicode: "e64a",
          unicode_decimal: 58954
        },
        {
          icon_id: "8776879",
          name: "play",
          font_class: "icon-test25",
          unicode: "e64b",
          unicode_decimal: 58955
        },
        {
          icon_id: "8776945",
          name: "discount",
          font_class: "icon-test27",
          unicode: "e64d",
          unicode_decimal: 58957
        },
        {
          icon_id: "8776987",
          name: "notification",
          font_class: "icon-test28",
          unicode: "e64e",
          unicode_decimal: 58958
        },
        {
          icon_id: "8776988",
          name: "notification_off",
          font_class: "icon-test29",
          unicode: "e650",
          unicode_decimal: 58960
        },
        {
          icon_id: "8776998",
          name: "phonecall",
          font_class: "icon-test30",
          unicode: "e651",
          unicode_decimal: 58961
        },
        {
          icon_id: "8776999",
          name: "phonecall_off",
          font_class: "icon-test31",
          unicode: "e652",
          unicode_decimal: 58962
        },
        {
          icon_id: "8777038",
          name: "lock",
          font_class: "icon-test32",
          unicode: "e653",
          unicode_decimal: 58963
        },
        {
          icon_id: "8777039",
          name: "unlock",
          font_class: "icon-test33",
          unicode: "e654",
          unicode_decimal: 58964
        },
        {
          icon_id: "8777050",
          name: "ET",
          font_class: "icon-test34",
          unicode: "e655",
          unicode_decimal: 58965
        },
        {
          icon_id: "8777078",
          name: "flow",
          font_class: "icon-test35",
          unicode: "e656",
          unicode_decimal: 58966
        },
        {
          icon_id: "8777080",
          name: "filter",
          font_class: "icon-test36",
          unicode: "e657",
          unicode_decimal: 58967
        },
        {
          icon_id: "8777131",
          name: "calculator",
          font_class: "icon-test37",
          unicode: "e658",
          unicode_decimal: 58968
        },
        {
          icon_id: "8777165",
          name: "image",
          font_class: "icon-test38",
          unicode: "e659",
          unicode_decimal: 58969
        },
        {
          icon_id: "8777166",
          name: "email",
          font_class: "icon-test39",
          unicode: "e65a",
          unicode_decimal: 58970
        },
        {
          icon_id: "8777224",
          name: "copy",
          font_class: "icon-test40",
          unicode: "e65b",
          unicode_decimal: 58971
        },
        {
          icon_id: "8777250",
          name: "user",
          font_class: "icon-test41",
          unicode: "e65c",
          unicode_decimal: 58972
        },
        {
          icon_id: "8777251",
          name: "customer_service",
          font_class: "icon-test42",
          unicode: "e65d",
          unicode_decimal: 58973
        },
        {
          icon_id: "8777252",
          name: "sub_account",
          font_class: "icon-test43",
          unicode: "e65e",
          unicode_decimal: 58974
        },
        {
          icon_id: "8777307",
          name: "partner",
          font_class: "icon-test44",
          unicode: "e65f",
          unicode_decimal: 58975
        },
        {
          icon_id: "8777371",
          name: "international",
          font_class: "icon-test46",
          unicode: "e661",
          unicode_decimal: 58977
        },
        {
          icon_id: "8777372",
          name: "refresh",
          font_class: "icon-test47",
          unicode: "e662",
          unicode_decimal: 58978
        },
        {
          icon_id: "8777387",
          name: "close_filled",
          font_class: "icon-test48",
          unicode: "e663",
          unicode_decimal: 58979
        },
        {
          icon_id: "8777388",
          name: "check",
          font_class: "icon-test49",
          unicode: "e664",
          unicode_decimal: 58980
        },
        {
          icon_id: "8777389",
          name: "close",
          font_class: "icon-test50",
          unicode: "e665",
          unicode_decimal: 58981
        },
        {
          icon_id: "8777390",
          name: "check_filled",
          font_class: "icon-test51",
          unicode: "e666",
          unicode_decimal: 58982
        },
        {
          icon_id: "8777399",
          name: "forbidden",
          font_class: "icon-test52",
          unicode: "e667",
          unicode_decimal: 58983
        },
        {
          icon_id: "8777402",
          name: "forbidden_filled",
          font_class: "icon-test53",
          unicode: "e668",
          unicode_decimal: 58984
        },
        {
          icon_id: "8777413",
          name: "info_filled",
          font_class: "icon-test54",
          unicode: "e669",
          unicode_decimal: 58985
        },
        {
          icon_id: "8777414",
          name: "info",
          font_class: "icon-test55",
          unicode: "e66a",
          unicode_decimal: 58986
        },
        {
          icon_id: "8777426",
          name: "help_filled",
          font_class: "icon-test56",
          unicode: "e66b",
          unicode_decimal: 58987
        },
        {
          icon_id: "8777427",
          name: "help",
          font_class: "icon-test57",
          unicode: "e66c",
          unicode_decimal: 58988
        },
        {
          icon_id: "8777429",
          name: "caution",
          font_class: "icon-test58",
          unicode: "e66d",
          unicode_decimal: 58989
        },
        {
          icon_id: "8777487",
          name: "caution_filled",
          font_class: "icon-test59",
          unicode: "e66e",
          unicode_decimal: 58990
        },
        {
          icon_id: "8777492",
          name: "like",
          font_class: "icon-test60",
          unicode: "e66f",
          unicode_decimal: 58991
        },
        {
          icon_id: "8777493",
          name: "like_filled",
          font_class: "icon-test61",
          unicode: "e670",
          unicode_decimal: 58992
        },
        {
          icon_id: "8777494",
          name: "star",
          font_class: "icon-test62",
          unicode: "e671",
          unicode_decimal: 58993
        },
        {
          icon_id: "8777495",
          name: "star_filled",
          font_class: "icon-test63",
          unicode: "e672",
          unicode_decimal: 58994
        },
        {
          icon_id: "8777509",
          name: "arrow_up",
          font_class: "icon-test64",
          unicode: "e673",
          unicode_decimal: 58995
        },
        {
          icon_id: "8777510",
          name: "arrow_left",
          font_class: "icon-test65",
          unicode: "e674",
          unicode_decimal: 58996
        },
        {
          icon_id: "8777511",
          name: "arrow_down",
          font_class: "icon-test66",
          unicode: "e675",
          unicode_decimal: 58997
        },
        {
          icon_id: "8777512",
          name: "arrow_right",
          font_class: "icon-test67",
          unicode: "e676",
          unicode_decimal: 58998
        },
        {
          icon_id: "8777532",
          name: "page_first",
          font_class: "icon-test68",
          unicode: "e677",
          unicode_decimal: 58999
        },
        {
          icon_id: "8777533",
          name: "down_to_bottom",
          font_class: "icon-test69",
          unicode: "e678",
          unicode_decimal: 59000
        },
        {
          icon_id: "8777534",
          name: "up_to_top",
          font_class: "icon-test70",
          unicode: "e679",
          unicode_decimal: 59001
        },
        {
          icon_id: "8777535",
          name: "page_last",
          font_class: "icon-test71",
          unicode: "e67a",
          unicode_decimal: 59002
        },
        {
          icon_id: "8777600",
          name: "page_turning_left",
          font_class: "icon-test72",
          unicode: "e67b",
          unicode_decimal: 59003
        },
        {
          icon_id: "8777601",
          name: "page_turning_right",
          font_class: "icon-test73",
          unicode: "e67c",
          unicode_decimal: 59004
        },
        {
          icon_id: "8777602",
          name: "show_less",
          font_class: "icon-test74",
          unicode: "e67d",
          unicode_decimal: 59005
        },
        {
          icon_id: "8777603",
          name: "show_more",
          font_class: "icon-test75",
          unicode: "e67e",
          unicode_decimal: 59006
        },
        {
          icon_id: "8777646",
          name: "social_fb",
          font_class: "icon-test76",
          unicode: "e67f",
          unicode_decimal: 59007
        },
        {
          icon_id: "8777647",
          name: "social_linkedin",
          font_class: "icon-test77",
          unicode: "e680",
          unicode_decimal: 59008
        },
        {
          icon_id: "8777649",
          name: "social_sina",
          font_class: "icon-test78",
          unicode: "e681",
          unicode_decimal: 59009
        },
        {
          icon_id: "8777650",
          name: "social_google",
          font_class: "icon-test79",
          unicode: "e682",
          unicode_decimal: 59010
        },
        {
          icon_id: "8777651",
          name: "social_naver",
          font_class: "icon-test80",
          unicode: "e683",
          unicode_decimal: 59011
        },
        {
          icon_id: "8777652",
          name: "social_stackflow",
          font_class: "icon-test81",
          unicode: "e684",
          unicode_decimal: 59012
        },
        {
          icon_id: "8777653",
          name: "social_youtube",
          font_class: "icon-test82",
          unicode: "e685",
          unicode_decimal: 59013
        },
        {
          icon_id: "8777654",
          name: "social_github",
          font_class: "icon-test83",
          unicode: "e686",
          unicode_decimal: 59014
        },
        {
          icon_id: "8777655",
          name: "social_twitter",
          font_class: "icon-test84",
          unicode: "e687",
          unicode_decimal: 59015
        },
        {
          icon_id: "8777656",
          name: "applets",
          font_class: "icon-test85",
          unicode: "e688",
          unicode_decimal: 59016
        },
        {
          icon_id: "8777657",
          name: "social_wechat",
          font_class: "icon-test86",
          unicode: "e689",
          unicode_decimal: 59017
        },
        {
          icon_id: "8777750",
          name: "social_server_fault",
          font_class: "icon-test87",
          unicode: "e68a",
          unicode_decimal: 59018
        },
        {
          icon_id: "8783413",
          name: "balance",
          font_class: "icon-test88",
          unicode: "e68b",
          unicode_decimal: 59019
        },
        {
          icon_id: "8918244",
          name: "go-to-link",
          font_class: "icon-test89",
          unicode: "e68c",
          unicode_decimal: 59020
        },
        {
          icon_id: "8918512",
          name: "benefits",
          font_class: "icon-test90",
          unicode: "e68d",
          unicode_decimal: 59021
        },
        {
          icon_id: "9096738",
          name: "dingtalk",
          font_class: "dingtalk",
          unicode: "e68e",
          unicode_decimal: 59022
        },
        {
          icon_id: "9096739",
          name: "alipay",
          font_class: "alipay",
          unicode: "e68f",
          unicode_decimal: 59023
        },
        {
          icon_id: "9096740",
          name: "taobao",
          font_class: "taobao",
          unicode: "e690",
          unicode_decimal: 59024
        },
        {
          icon_id: "9096741",
          name: "1688",
          font_class: "icon-test91",
          unicode: "e691",
          unicode_decimal: 59025
        },
        {
          icon_id: "8776706",
          name: "message_unread",
          font_class: "icon-test",
          unicode: "e636",
          unicode_decimal: 58934
        },
        {
          icon_id: "8776715",
          name: "time",
          font_class: "icon-test1",
          unicode: "e638",
          unicode_decimal: 58936
        },
        {
          icon_id: "8776842",
          name: "search",
          font_class: "icon-test2",
          unicode: "e63c",
          unicode_decimal: 58940
        },
        {
          icon_id: "8776871",
          name: "link",
          font_class: "icon-test3",
          unicode: "e63e",
          unicode_decimal: 58942
        },
        {
          icon_id: "8776944",
          name: "region",
          font_class: "icon-test4",
          unicode: "e641",
          unicode_decimal: 58945
        },
        {
          icon_id: "8777370",
          name: "list",
          font_class: "icon-test5",
          unicode: "e64f",
          unicode_decimal: 58959
        }
      ],
      visible: false
    };
  },
  created: function() {
    this.getList();
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.getDetail();
    }
  },
  methods: {
    selectIcon(val) {
      this.ruleForm.icon = val;
      this.visible = !this.visible;
    },
    handleChange(val) {
      this.ruleForm.pid = val[val.length - 1];
      this.ruleForm.path = val.join(",");
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let param = {
            type: Number(this.ruleForm.type),
            name: this.ruleForm.name,
            pid: this.ruleForm.pid,
            path: Array.isArray(this.ruleForm.path)
              ? this.ruleForm.path.join(",")
              : this.ruleForm.path,
            sort: Number(this.ruleForm.sort),
            icon: this.ruleForm.icon,
            // dept: this.ruleForm.dept
            apisAuth: JSON.stringify(this.ruleForm.apisAuth.split(",")),
            code: "",
            dept: 2,
            url: this.ruleForm.url,
            id: 0
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/sys/menu/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success"
                });
                this.$router.go(-1);
              })
              .catch()
              .finally();
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/sys/menu/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success"
                });
                this.$router.go(-1);
              })
              .catch()
              .finally();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleRemove(file) {
      console.log(file);
    },
    handleDownload(file) {
      console.log(file);
    },
    goBack() {
      this.$router.go(-1);
    },
    close() {
      this.$router.go(-1);
    },
    statusChange() {
      if (this.ruleForm.role.length > 1) {
        this.ruleForm.role.splice(0, 1);
      }
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize
      };
      this.$axios
        .post(`/admapi/sys/menu/list`, param)
        .then(({ data }) => {
          data.push({
            id: 0,
            name: "顶级"
          });
          this.postList = data;
        })
        .catch()
        .finally();
    },
    getDetail() {
      let param = {
        id: this.editId
      };
      this.$axios
        .post(`/admapi/sys/menu/detail`, param)
        .then(({ data }) => {
          this.ruleForm.name = data.name;
          this.ruleForm.type = JSON.stringify(data.type);
          this.ruleForm.pid = data.pid;
          this.selectData = data.path.split(",").map(Number);
          this.ruleForm.path = data.path.split(",");
          this.ruleForm.url = data.url;
          this.ruleForm.sort = data.sort;
          this.ruleForm.apisAuth = JSON.parse(data.apisAuth).join(",");
          let icon = data.icon;
          for (var i = 0; i < this.iconList.length; i++) {
            if (icon == this.iconList[i].font_class) {
              this.ruleForm.icon = icon;
              return;
            } else {
              this.ruleForm.icon = "";
            }
          }
          this.ruleForm.dept = JSON.stringify(data.dept);
        })
        .catch()
        .finally();
    }
  }
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
.iconBox {
  width: 500px;
  display: flex;
  flex-wrap: wrap;
}
</style>
